import i18n from "@/i18n";
import globalMethods from "@/globalMethods";
import {URLS, RESPONSES} from "@/constants";
import {notify} from "@/plugins/notification";


export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getPromoCode(_, code) {
            const url = `${URLS.MODEL.PROMO_CODE.PROMO_CODE_URL}?code=${code}`;
            const options = {
                method: "GET",
                credentials: "include",
            };
            const successfulHandler = (data) => {
                if (data.data.is_active) {
                    notify(i18n.global.t("Promo code successfully applied"), "black", 5000);
                    return {successfully: true, data: data.data};
                } else {
                    notify(i18n.global.t("The promo code has expired and is no longer valid. Please try entering a different one"), "black", 5000);
                    return {successfully: false};
                }
            };
            const errorHandler = (data) => {
                if (data.detail === RESPONSES.NOT_FOUND) {
                    notify(i18n.global.t("The specified promo code was not found. Please check the spelling and try again"), "black", 5000);
                    return {successfully: false};
                }
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler, errorHandler: errorHandler});
        },
    },
};